<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="display: flex; flex-flow: column; height: 100%;" class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; max-height: 80px">
                <v-col class="ml-4 mt-0 pt-1 RestoRegular">
                    <v-row style="font-size: 18px; color: #4D4D4D; max-width: 300px" class="pt-2">
                        Un par de datos más para validar 
                        el paso anterior
                    </v-row>
                    <!-- <v-snackbar v-model="isError" :top="true" color="error">
                        ¡Falta llenar algún campo!
                    </v-snackbar> -->
                    <!-- <v-snackbar v-model="alert" :top="true" color="error">
                        {{ alertmensaje }}
                    </v-snackbar>                     -->
                </v-col>
            </v-row>

            <!-- New content -->
            <v-row style="flex-grow : 1;" class="py-0 my-0" >
                <v-col style="height: 100%" class="py-0 my-0">
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.calle" :rules="[rules.required]" label="Calle" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row>
                    <v-row style="margin: 0 auto; max-width: 350px;" class="my-0 py-0">
                        <v-col class="pl-0">
                            <v-text-field v-model="address.num_exterior" :rules="[rules.required]" label="No. Exterior" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                        </v-col>
                        <v-col class="pr-0">
                            <v-text-field v-model="address.num_interior" label="No. Interior" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                        </v-col>
                    </v-row>                    
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.colonia" :rules="[rules.required]" label="Colonia"  class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.cp" :rules="[rules.required]" id="cp" label="Código Postal"  class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.referencias" :rules="[rules.required]" label="Referencias" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row> 
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="address.alias" :rules="[rules.required]" label="Alias de tu dirección" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                    </v-row> 
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <br><br>
                    </v-row>
                </v-col>
            </v-row>
            <!-- Button Continue -->
            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%"  >
                <!-- v-if="checkAddress==true" -->
                <br><br><br>
                <v-btn @click="goTo()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px;">Continuar</span>
                    <v-spacer></v-spacer>
                    <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                </v-btn>
            </v-row>    
            <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%"  >
                <v-btn @click="$router.push({ name: 'newAddress'}); " class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
                    <span style="float: left; padding-left:0px; color: $store.state.colors.primary">Regresar</span>
                    <v-spacer></v-spacer>
                </v-btn>
            </v-row> 
        </v-col>
    </v-row>
</template>

<script>
import $ from 'jquery'
require('jquery-mask-plugin');
export default {
    data()
    {
        return{
                address:{
                    id_cliente:'',
                    alertM:false,
                    alias:'',
                    predeterminada:'',
                    calle:localStorage.getItem("calle"),
                    num_exterior:localStorage.getItem("num_exterior"),
                    num_interior:'',
                    cp:localStorage.getItem("cp"),
                    colonia:localStorage.getItem("colonia"),
                    ciudad:localStorage.getItem("ciudad"),
                    estado:localStorage.getItem("estado"),
                    pais:'México',
                    referencias:'',
                },
                alert: false,
                alertmensaje: 'Ocurrió un error',
                rules:
                {
                    required: value => !!value || ''
                },
                longitude:null,
                latitude:null,
                isError: false,
        }
    },
    mounted() {
        $('document').ready(function() {
            $("#cp").mask("00000");
        });
    },
    computed:{
      checkAddress: function (){
        if (this.address.calle && this.address.num_exterior && this.address.colonia && this.address.cp) { 
          return true 
        } return false;
      },
    },
    methods:
    {
        alertMessage(){
            this.alertM=true;
        },
        goTo() 
        {
            if(( !!this.address.calle && !!this.address.num_exterior && !!this.address.colonia && !!this.address.cp && !! this.address.referencias)){
                var dirTemp = {
                    id_cliente: null,
                    codigo_marca: null,
                    alias: null,
                    predeterminada: null,
                    calle: null,
                    num_exterior: null,
                    num_interior: null,
                    cp: null,
                    colonia: null,
                    ciudad: null,
                    estado: null,
                    pais: null,
                    referencias: null,
                    longitud: null,
                    latitud: null
                }
                dirTemp.id_cliente = this.$store.state.id_cliente; 
                dirTemp.codigo_marca = this.$store.state.codigo_marca; 
                dirTemp.alias = this.address.alias;
                dirTemp.predeterminada = 'N',
                dirTemp.calle = this.address.calle, 
                dirTemp.num_exterior = this.address.num_exterior,
                dirTemp.num_interior = this.address.num_interior, 
                dirTemp.cp = this.address.cp,
                dirTemp.colonia = this.address.colonia,
                dirTemp.ciudad = this.address.ciudad,
                dirTemp.estado = this.address.estado,
                dirTemp.pais = this.address.pais,      
                dirTemp.referencias = this.address.referencias,
                dirTemp.longitud = localStorage.getItem("longitude"),  
                dirTemp.latitud = localStorage.getItem("latitude"),  
                console.log("EL OBJETO DIRECCION A EDITAR: ",dirTemp);
                this.$router.push({ name: 'userprofile'});
            }else{
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "¡Falta llenar un campo!";
                this.$store.state.alertColor = "error";
                setTimeout(() => {
                    this.$store.state.alertState = false;
                }, 4000);  
            }
        },

    }
}
</script>

<style scoped>
.disable-events 
{
    pointer-events: none;
}
</style>